import { TypeConfiguration } from '../../interfaces/Configuration/Configuration'
import { TypeConfigurationAction } from '../actions/typeConfigurationActions'
import { GET_TYPE_CONFIGURATION_EXITO } from '../types/typeConfigurationtActionsTypes'

export interface TypeConfigurationState {
  typeConfigurationState: {
    typeConfiguration: TypeConfiguration[]
    error?: string | undefined
  }
}

const initialState: TypeConfigurationState = {
  typeConfigurationState: { typeConfiguration: [], error: '' }
}

export const typeConfigurationReducer = (
  state: TypeConfigurationState = initialState,
  action: TypeConfigurationAction
): TypeConfigurationState => {
  if (action.type === GET_TYPE_CONFIGURATION_EXITO) {
    return {
      ...state,
      typeConfigurationState: {
        typeConfiguration: action.typeConfiguration,
        error: action.error
      }
    }
  }
  return state
}
